import React, { type ReactElement } from 'react';

import { FlagsProvider } from '@atlaskit/flag';

import { Attribution, TransparentErrorBoundary } from '@confluence/error-boundary';
import { LoadableBackground } from '@confluence/loadable';

const AiUpsellModalLoadable = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluenceAiUpsellModal" */ '../src/AiUpsellModal'
			)
		).AiUpsellModal,
});

export const LoadableConfluenceAiUpsellModal = ({
	onCloseModal,
	children,
}: {
	onCloseModal: () => void;
	children?: ReactElement;
}) => {
	return (
		<FlagsProvider>
			<TransparentErrorBoundary attribution={Attribution.GROWTH_TAKO}>
				<AiUpsellModalLoadable onCloseModal={onCloseModal}>{children}</AiUpsellModalLoadable>
			</TransparentErrorBoundary>
		</FlagsProvider>
	);
};
